import {
  VenueBillingMonth,
  VenueBillingMonthDetail,
} from '@models/VenueBilling'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  VENUE_BILLING_URL,
  VENUE_BILLING_VENUES_EXPORT_URL,
} from '@utils/urls'

// Trailing window of monthly summaries (default 12 months + current).
const fetchVenueBillingMonths = (months?: number) =>
  SBAPI.Fetch<VenueBillingMonth[]>(
    VENUE_BILLING_URL,
    months ? { months: String(months) } : {}
  ).then((res) => res.data)

// Per-venue drill-down for one month (YYYY-MM).
const fetchVenueBillingMonth = (month: string) =>
  SBAPI.Fetch<VenueBillingMonthDetail>(`${VENUE_BILLING_URL}/${month}`).then(
    (res) => res.data
  )

// Full venue list as raw CSV text. Unlike the other endpoints this returns
// text/csv (not a JSON envelope), so the body is the CSV string itself.
const fetchVenuesExportCsv = (): Promise<string> =>
  SBAPI.Fetch<string>(VENUE_BILLING_VENUES_EXPORT_URL) as unknown as Promise<string>

export {
  fetchVenueBillingMonths,
  fetchVenueBillingMonth,
  fetchVenuesExportCsv,
}
